import React, {Component} from 'react'
import { connect } from "react-redux";
import _ from 'lodash';
import { fetchClient, updateClient } from '../../../actions/admin';
import {startLoading, endLoading} from '../../../actions/loadingActions';
import ModalChangeUserData from './ModalChangeUserData';
import UserAvatar from 'react-user-avatar';

import Casos from '../../casos/Casos'

class Client extends Component{
    constructor(props) {
        super(props);
        this.state = {
            client: null,
            casos:[],
            showUserModal: false
        };
    }
    componentDidMount() {
        this.props.fetchClient(this.props.match.params.id);
    }
    componentDidUpdate(prevProps, prevState){
        if(this.props === prevProps){
            return false;
        }
        this.setState({
            client: this.props.client,
            casos: this.props.client.name
        })
    }
    toggleModalUser() {
        this.setState({
            showUserModal: !this.state.showUserModal
        })
    }
    updateUserAction(data, userid){
        this.props.updateClient(data, userid);
    }
    render(){
        return(
        <div>
            <div className="justify-content-md-center">
                <div className="col-md-12 content-container content-title">
                    <h1><UserAvatar src={this.state.client && this.state.client.avatar} className="m-2" size="52" name={this.state.client && this.state.client.name || "-"} />{this.state.client && this.state.client.name}</h1>
                    <hr/>
                    <div className="row">
                        <div className="col-md-10">
                            <dl className="row">
                                <dt className="col-sm-3">Email:</dt>
                                <dd className="col-sm-9">{this.state.client && this.state.client.email}</dd>
                                <dt className="col-sm-3">Número de colegiado:</dt>
                                <dd className="col-sm-9">{this.state.client && this.state.client.num_colegiado}</dd>
                                <dt className="col-sm-3">Teléfono:</dt>
                                <dd className="col-sm-9">{this.state.client && this.state.client.phone}</dd>
                            </dl>
                        </div>
                        <div className="col-md-2">
                            <button
                                type="button"
                                className="btn btn-sm btn-outline-primary next float-right"
                                onClick={this.toggleModalUser.bind(this)}
                            >
                                Editar datos del cliente &nbsp;
                                <i className="fa fa-pencil"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <ModalChangeUserData
                isOpen={this.state.showUserModal}
                toggler={this.toggleModalUser.bind(this)}
                action={this.updateUserAction.bind(this)}
                title="Editar datos del cliente"
                client={this.state.client}
                button="Guardar"
            />
            <Casos
                userId={this.props.match.params.id}
                client={this.props.client}
            />
        </div>

        )
    }
}

function mapStateToProps(state) {
    return {
        client: state.client,
        casos: state.casos.data,
        pagination: _.omit(state.casos, "data"),
        loading: state.loading
    };
}

export default connect(mapStateToProps,
    {
        updateClient,
        fetchClient,
        startLoading,
        endLoading,
    })(Client);


// WEBPACK FOOTER //
// ./resources/assets/js/components/admin/clients/Client.jsx